import { ColumnApi, GridApi } from '@ag-grid-community/core';
import { DependencyList, useCallback } from 'react';
import { createSearchParams, useSearchParams } from 'react-router-dom';
import { DEFAULT_SORT_ORDER } from '../../pages/data-tools/document-search/DocumentSearch.constants';

export type TableQueryResult = {
  onSortChanged: <T extends { columnApi: ColumnApi; api?: GridApi }>(event: T) => void;
};

export default (extraDependencies: DependencyList = [], defaultSortField = '', defaultSortOrder = DEFAULT_SORT_ORDER): TableQueryResult => {
  const [searchParams, setSearchParams] = useSearchParams();

  const onSortChanged = useCallback(
    (event) => {
      if (event.api?.getDisplayedRowCount() > 0) {
        event.api.ensureIndexVisible(0, 'top');
      }

      const column = event.columnApi.getColumnState().find((c) => c.sort);
      const params = createSearchParams(searchParams);
      if (!column) {
        params.set('sortField', defaultSortField);
        params.set('sortOrder', defaultSortOrder);
        event.columnApi.applyColumnState({ state: [{ colId: defaultSortField, sort: defaultSortOrder }] });
      } else {
        params.set('sortField', column.colId);
        params.set('sortOrder', column.sort || defaultSortOrder);
      }
      setSearchParams(params, { replace: true });
    },
    [searchParams, ...extraDependencies]
  );

  return {
    onSortChanged,
  };
};
